import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

const OPTION_ID_PREFIX = "option_";

function optionIdNew(id?: string): string {
  return id ? id : `${OPTION_ID_PREFIX}${uid()}`;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_231: DocMigration = {
  maxSchemaVersion: "0.0.231",
  description: "Include on master plan set moved to individual options.",
  apply(json: any) {
    if (json.optionSets) {
      for (const optionSetId in json.optionSets) {
        const optionSet = json.optionSets[optionSetId];

        // set the id for options without an id
        for (const key in optionSet.options) {
          const option = optionSet.options[key];
          option.id = optionIdNew(option.id);
        }

        // migrate includeOnMasterPlanSet to includeOptionOnMasterPlanSet
        const auxOptionSet = json.auxOptionSets[optionSetId];
        if (auxOptionSet?.includeOnMasterPlanSet !== undefined) {
          auxOptionSet.includeOptionOnMasterPlanSet = {};
          for (const key in optionSet.options) {
            const option = optionSet.options[key];
            auxOptionSet.includeOptionOnMasterPlanSet[option.id] = auxOptionSet.includeOnMasterPlanSet;
          }

          delete auxOptionSet.includeOnMasterPlanSet;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_231;
